import { type NodeRect } from './layout/nodeLayout';

export type FlowRect = { height: number; width: number; x: number; y: number };

export function computeVisibleFraction(target: FlowRect, viewport: FlowRect): number {
  const targetArea = target.width * target.height;

  if (targetArea <= 0) {
    return 1;
  }

  const overlapLeft = Math.max(target.x, viewport.x);
  const overlapTop = Math.max(target.y, viewport.y);
  const overlapRight = Math.min(target.x + target.width, viewport.x + viewport.width);
  const overlapBottom = Math.min(target.y + target.height, viewport.y + viewport.height);

  const overlapWidth = Math.max(0, overlapRight - overlapLeft);
  const overlapHeight = Math.max(0, overlapBottom - overlapTop);

  return (overlapWidth * overlapHeight) / targetArea;
}

export function getBoundsFromRects(rects: NodeRect[]): FlowRect {
  const minX = Math.min(...rects.map((r) => r.x));
  const minY = Math.min(...rects.map((r) => r.y));
  const maxX = Math.max(...rects.map((r) => r.x + r.width));
  const maxY = Math.max(...rects.map((r) => r.y + r.height));

  return {
    height: maxY - minY,
    width: maxX - minX,
    x: minX,
    y: minY,
  };
}
